<template #content>

    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="preenchimento" v-model="contrato.preenchimento" class="w-full" disabled />
                        <label for="preenchimento">Documento Preeenchido<span class="text-red-500">**</span></label>
                    </FloatLabel>
                    <Button icon="pi pi-download" severity="primary"
                        @click="download({ id: contrato.preenchimento_id, nome: contrato.preenchimento })" :disabled="!contrato.preenchimento_id" />
                    <Button icon="pi pi-eye" severity="secondary" @click="visualizar({ id: contrato.preenchimento_id, nome: contrato.preenchimento })"
                        :disabled="!contrato.preenchimento_id"></Button>
                    <Button icon="pi pi-trash" severity="danger" @click="remove(contrato.preenchimento_id)"
                        :disabled="!contrato.preenchimento_id"></Button>
                </InputGroup>
                <div class="text-xs text-right">
                    <template v-if="contrato.preenchimento_usuario">
                        {{ contrato.preenchimento_usuario }} ({{ dateFormat(contrato.preenchimento_date) }})
                    </template>
                </div>
            </div>
        </div>



            <Fieldset legend="Upload de Arquivo">
            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingPreenchimento" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogPreenchimento"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingPreenchimento"
                                @click="handleUploadPreenchimento"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogPreenchimento"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondPreenchimento"
                        name="arquivo"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="image/*"
                        :files="filesPreenchimento"
                        @updatefiles="onFileUpdatePreenchimento"
                        :allowMultiple="true"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingPreenchimento" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                </div>
            </BlockUI>
        </Fieldset>


            <!--<div class="w-full">
                <FileUpload ref="upload" name="arquivo" :url="uploadUrl()" chooseIcon="pi pi-file-plus"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" @upload="onUploaded"
                    @error="onUploadError" :maxFileSize="50000000">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>-->




        <div class="w-full">
            <Toolbar class="mb-2 bg-gray-100">
                <template #start>
                    <div class="font-semibold">Versões</div>
                </template>
                <template #end>
                    <div class="flex items-center gap-1">
                        <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
                    </div>
                </template>
            </Toolbar>

            <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                @sort="onTableSort">

                <Column style="width: 100px" field="id" header="#" sortable></Column>
                <Column field="nome" header="nome" sortable></Column>
                <Column field="created_at" header="Criação" sortable>
                    <template #body="{ data }">
                        {{ dateFormat(data.created_at) }}
                    </template>
                </Column>

                <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                    <template #body="{ data }">
                        <Button icon="pi pi-download" title="Baixar" severity="primary" size="small"
                            @click="download(data)" />
                        <Button icon="pi pi-eye" title="Visualizar" severity="secondary" size="small"
                            @click="visualizar(data)" />
                        <Button icon="pi pi-trash" title="Remover" severity="danger" size="small"
                            @click="remove(data.id, true)" />
                    </template>
                </Column>

                <template #empty>
                    <div class="text-center text-gray-600">
                        Nenhum registro encontrado
                    </div>
                </template>
            </DataTable>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <div class="flex justify-end mt-2 text-sm text-gray-600">
                        <span>{{ pagination.total }} registros</span>
                    </div>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                        @page="onPage">
                    </Paginator>
                </div>
                <div class="flex align-items-center justify-content-center">
                </div>
            </div>
        </div>

    </div>

</template>
<script>

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import FileUpload from 'primevue/fileupload';
import Dialog from 'primevue/dialog';

import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
const FilePond = vueFilePond(FilePondPluginFileValidateType)
import ProgressSpinner from 'primevue/progressspinner';
import BlockUI from 'primevue/blockui';
import Fieldset from 'primevue/fieldset';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import PreenchimentoVersao from '@/service/preenchimentoVersao.js';
import Arquivo from '@/service/arquivo.js';

import Token from '@/utils/Token';
import File from '@/utils/File';

import Moment from 'moment';
import Filter from '@/utils/Filter.js';

export default {
    components: {
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        InputGroup,
        InputGroupAddon,
        Dialog,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        FileUpload,
        FilePond,
        ProgressSpinner,
        BlockUI,
        Fieldset,
    },
    props: {
        contrato: {},
        permissoes: {},
    },
    emits: ['save'],
    data() {
        return {
            isLoading: false,
            lista: [],
            item: {},
            visibleForm: false,
            visibleVisualizar: false,
            documentoVisualizar: null,

            filesPreenchimento: [],
            isLoadingPreenchimento: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: -1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },

        }
    },
    mounted() {
        this.loadData();
    },
    methods: {


        // Instalação
        onFileUpdatePreenchimento(files) {
            this.filesPreenchimento = files.map(file => file.file)
        },
        openFileDialogPreenchimento() {
            this.$refs.pondPreenchimento.browse()
        },
        clearFileDialogPreenchimento() {
            this.filesPreenchimento= []
        },

        async handleUploadPreenchimento() {

            if (this.filesPreenchimento.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingPreenchimento = true

            const formData = new FormData()
            this.filesPreenchimento.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                const response = await Arquivo.contratoPreenchimento(this.contrato.id, formData)

                this.filesPreenchimento = []

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Provedor incluído com sucesso.`,
                    life: 3000
                })

                this.$emit('save', response.data);
                this.loadData()


            } catch (error) {
                console.log(error);
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingPreenchimento = false
            }
        },


        uploadUrl() {
            return Arquivo.contratoPreenchimento(this.contrato.id);
        },
        beforeUpload(request) {
            let token = Token.get();
            request.xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            // pode incluir dados no upload
            return request;
        },
        onUploadError(event) {
            let error = JSON.parse(event.xhr.response);
            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.msg, life: 5000 });
        },
        onUploaded(event) {
            this.$refs.upload.clear();
            this.$refs.upload.uploadedFileCount = 0;

            let data = JSON.parse(event.xhr.response);
            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O arquivo foi enviado com sucesso.', life: 3000 });
            this.$emit('save', data);

            this.loadData();
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        visualizar(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.openWindow(response);
                });
        },
        download(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.download(response);
                });
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        saveForm(arquivo = null) {
            this.$emit('save', arquivo);
            this.loadData();
        },
        remove(arquivoID, versao = false) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Arquivo.delete(arquivoID)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            if (versao) {
                                this.loadData();
                            } else {
                                this.saveForm({});
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            PreenchimentoVersao.listContrato(this.contrato.id, params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },
    }
}
</script>

<style>
.contrato-endereco .p-panel-header {
    padding-bottom: 0;
}
</style>
